
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import AppBox from '@/components/AppBox.vue'
import AppButton from '@/components/AppButton.vue'
import AppContainer from '@/components/AppContainer.vue'
import HomeAppItemBrand from '@/components/HomeAppItemBrand.vue'
import CommonAppItemPlatform from '@/components/CommonAppItemPlatform.vue'
import HomeAppItemAccount from '@/components/HomeAppItemAccount.vue'
import CommonRenewAppleMembership from '@/components/CommonRenewAppleMembership.vue'
import CommonAppWarning from '@/components/CommonAppWarning.vue'
import { ChildComponentMixin } from '@/mixins'
import { cloneDeep } from 'lodash'
import { iOSLoginUrl } from '@/utils/fastlane'

@Component({
    components: {
        AppBox,
        AppButton,
        AppContainer,
        CommonAppItemPlatform,
        CommonAppWarning,
        CommonRenewAppleMembership,
        HomeAppItemAccount,
        HomeAppItemBrand,
    },
})
export default class HomeAppItem extends ChildComponentMixin {
    @Prop() private app!: AppEntity

    get showAppAccount(): boolean {
        return this.app.iOS !== undefined && this.app.account !== undefined
    }

    get appleMembership() {
        return this.app.iOS && this.app.iOS.appleMembership
    }

    private onChangeApp(appInfo: AppInfoEntity, platform: string) {
        const updatedApp = cloneDeep(this.app)
        if (platform === 'android') {
            updatedApp.android = appInfo
        } else {
            updatedApp.iOS = appInfo
        }

        this.$store.dispatch('home/replaceApp', updatedApp)
    }

    private onUpdateSession() {
        window.open(iOSLoginUrl(this.app), '_blank')
    }
}
